import React from 'react';
import { getDocumentTypeSelectionKey, getOrderedDocumentTypes } from '../utils/documentTypeUtils';

/**
 * 文書種別オプションコンポーネント
 * 保険種別に応じて並び替えられた文書種別のチェックボックスリストを表示する
 * 各項目は selectionKey をキーとして onDocumentTypeToggle でトグル可能
 * 
 * @param {string} insuranceType - 保険種別（並び順の決定に使用）
 * @param {Array} documentTypes - 文書種別リスト
 * @param {Array} selectedDocumentTypeIds - 選択済み文書種別IDの配列
 * @param {Function} onDocumentTypeToggle - 文書種別トグル時のコールバック関数
 * @returns {Array<JSX.Element>} チェックボックス要素の配列
 */
const DocumentTypeOptions = ({
  insuranceType,
  documentTypes = [],
  selectedDocumentTypeIds = [],
  onDocumentTypeToggle = () => {}
}) => {
  // 保険種別に基づいて並び順を整えた文書種別リストを取得
  const orderedTypes = getOrderedDocumentTypes(documentTypes, insuranceType);
  
  // 並び替え済みの文書種別をマップしてチェックボックスを生成
  return orderedTypes.map((type) => {
    // IDが存在しない場合はスキップ
    if (!type.id) {
      return null;
    }
    
    // 文書種別の選択キーを取得（保険種別を含む一意のキー）
    const selectionKey = getDocumentTypeSelectionKey(type);
    
    // 現在の文書種別が選択済みかどうかをチェック
    const isChecked = selectedDocumentTypeIds.includes(selectionKey);
    
    return (
      <label key={selectionKey} className="checkbox-native-box document-type-option c-mr-20">
        <input
          className="checkbox-native"
          type="checkbox"
          checked={isChecked}
          onChange={() => onDocumentTypeToggle(selectionKey)}
        />
        {/* 文書種別の表示名 */}
        <span>{type.name || type.code}</span>
      </label>
    );
  });
};

export default DocumentTypeOptions;